import { Icon } from '@smg-real-estate/domus';

import { AgentService, AgentSpecialization } from '@/types/agentProfile';

export interface ServiceChip {
  key: string;
  icon: Icon;
  labelKey: string;
}

export const SERVICE_CHIPS: Record<AgentService, Omit<ServiceChip, 'key'>> = {
  [AgentService.RealEstateManagement]: {
    icon: Icon.HouseWithGear,
    labelKey: 'agentServices.realEstateManagement',
  },
  [AgentService.Sales]: {
    icon: Icon.Award,
    labelKey: 'agentServices.sales',
  },
  [AgentService.Marketing]: {
    icon: Icon.Target,
    labelKey: 'agentServices.marketing',
  },
  [AgentService.GeneralContracting]: {
    icon: Icon.ConstructionBlock,
    labelKey: 'agentServices.generalContracting',
  },
  [AgentService.Valuation]: {
    icon: Icon.HouseWithEuroSign,
    labelKey: 'agentServices.valuation',
  },
};

export const SPECIALIZATION_CHIPS: Record<AgentSpecialization, Omit<ServiceChip, 'key'>> = {
  [AgentSpecialization.InitialMarketing]: {
    icon: Icon.Target,
    labelKey: 'agentSpecializations.initialMarketing',
  },
  [AgentSpecialization.FirstRentals]: {
    icon: Icon.BuildingApartment,
    labelKey: 'agentSpecializations.firstRentals',
  },
  [AgentSpecialization.CommercialOffice]: {
    icon: Icon.BuildingCommercial,
    labelKey: 'agentSpecializations.commercialOffice',
  },
  [AgentSpecialization.InvestmentProperties]: {
    icon: Icon.Financing,
    labelKey: 'agentSpecializations.investmentProperties',
  },
  [AgentSpecialization.LuxuryProperties]: {
    icon: Icon.BuildingLuxury,
    labelKey: 'agentSpecializations.luxuryProperties',
  },
};

/** Every service + specialization chip, used by agent result cards. */
export const allAgentServiceChips = (): ServiceChip[] => [
  ...Object.entries(SERVICE_CHIPS).map(([key, chip]) => ({ key, ...chip })),
  ...Object.entries(SPECIALIZATION_CHIPS).map(([key, chip]) => ({ key, ...chip })),
];

/**
 * Agent focus filters from the directory Figma, in that order.
 * "New construction" is the display label for the generalContracting service.
 */
export const agentFocusChips = (): ServiceChip[] => [
  {
    key: AgentSpecialization.InitialMarketing,
    ...SPECIALIZATION_CHIPS[AgentSpecialization.InitialMarketing],
  },
  {
    key: AgentSpecialization.InvestmentProperties,
    ...SPECIALIZATION_CHIPS[AgentSpecialization.InvestmentProperties],
  },
  {
    key: AgentService.GeneralContracting,
    icon: SERVICE_CHIPS[AgentService.GeneralContracting].icon,
    labelKey: 'agentFocus.newConstruction',
  },
  {
    key: AgentSpecialization.LuxuryProperties,
    ...SPECIALIZATION_CHIPS[AgentSpecialization.LuxuryProperties],
  },
  {
    key: AgentSpecialization.FirstRentals,
    ...SPECIALIZATION_CHIPS[AgentSpecialization.FirstRentals],
  },
  {
    key: AgentSpecialization.CommercialOffice,
    ...SPECIALIZATION_CHIPS[AgentSpecialization.CommercialOffice],
  },
];
